module.exports = __webpack_public_path__ + "assets/img/20.491e92d7.png";